import { mapActions } from "vuex";

export default {
  name: "TabBar",
  props: ["tab", "is_premium","isBrokerUser", "isBrokerGuest"],

  computed: {
    classNameTradingAnalysis: function() {
      if (this.tab === "TradingAnalysis" || (this.is_premium==1 && this.tab === "pdf" && (isBrokerUser==false || this.isBrokerGuest == true))) return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNamePortfolio: function() {
      if (this.tab === "Portfolio" || (this.is_premium==0 && this.tab === "pdf")) return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNameRating: function() {
      if (this.tab === "rating") return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNameSector: function() {
      if (this.tab === "sector") return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNameGrowth: function() {
      if (this.tab === "growth") return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNamePerformance: function() {
      if (this.tab === "performance") return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNameRecommendations: function() {
      if (this.tab === "recommendations") return "nav-link alphatab active";
      else return "nav-link alphatab";
    },
    classNameExisitvsrestruct: function() {
      if (this.tab === "exisitvsrestruct") return "nav-link alphatab active";
      else return "nav-link alphatab";
    }
  },

  methods: {
    ...mapActions("portfolioreport", {
      setTab: "setTab"
    }),

    onTabClick(tab) {
      this.setTab(tab);
    }
  }
};




// WEBPACK FOOTER //
// ./src/assets/js/Report/TabBar.js